import { ChangeEvent, FC, useCallback } from "react";
import { useFilterItem, useSetFilterItem } from "../../../state";

const ListFilter: FC<{
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  onGeomSelectionClick: () => void;
  haveMultipleSelection: boolean;
  geometrySelectActive: boolean;
  filter?: string;
}> = (props) => {
  const setFilterItem = useSetFilterItem();
  const filterItem = useFilterItem();
  const onClearMultiFilterClick = useCallback(() => {
    setFilterItem(null);
  }, [setFilterItem]);

  return (
    <div>
      <div style={{ margin: 5 }}>
        {/* <Link to="../filter">
          <i
            className="fa fa-filter"
            style={{
              fontSize: 25,
              position: "relative",
              float: "left",
              top: 0,
              left: 5,
              marginBottom: 8,
            }}
          />
        </Link> */}
        {filterItem ? (
          <i
            className="fa fa-times-circle-o"
            style={{
              fontSize: 25,
              position: "relative",
              float: "left",
              top: 0,
              left: 20,
              marginBottom: 5,
            }}
            onClick={onClearMultiFilterClick}
          />
        ) : null}
        {/* {canMultiedit && props.haveMultipleSelection ? (
          <Link to="../filter">
            <i
              className="fa fa-edit"
              style={{
                fontSize: 25,
                position: "relative",
                float: "right",
                top: 0,
                right: 80,
                marginBottom: 5,
              }}
            />
          </Link>
        ) : null} */}
        {/* <i
          className="fa fa-magic"
          style={{
            fontSize: 25,
            position: "absolute",
            float: "right",
            top: 5,
            right: 10,
            marginBottom: 5,
            backgroundColor: props.geometrySelectActive ? "#007AFF" : "rgba(255,255,255,255)",
          }}
          onClick={props.onGeomSelectionClick}
        /> */}
      </div>
      <div style={{ padding: 5 }}>
        <input type="search" placeholder="Filter" className="form-control" value={props.filter} onChange={props.onChange} />
        {props.filter ? (
          <i
            className="fa fa-times-circle-o"
            style={{
              fontSize: 25,
              position: "relative",
              float: "right",
              top: -30,
              right: 10,
              marginBottom: -20,
            }}
            onClick={props.onClear}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ListFilter;
